<template>
  <div class="comp_body">
    <div class="comp_title">
        BÓKASAFNIÐ MITT
    </div>
    <img class="comp_forlagid_logo" src="/static/img/hvit_fjodur.svg">
    <div class="comp_cmds">
      <a class="link" href="https://www.forlagid.is/voruflokkur/hljodbaekur-og-tonlist/streymi/">Verslun</a>
      &nbsp;
      <span class="link" v-on:click="$emit('show-user')">Notandi</span>
    </div>
    <div class="comp_no_assets" v-show=show_no_asset_msg>
      <h4 style="margin-top:30px">Engar bækur?</h4>
      <div>
        Kauptu <a class="link2" href="https://www.forlagid.is/voruflokkur/hljodbaekur-og-tonlist/streymi/">Hljóðbók - streymi á heimasíðu Forlagsins</a> og þá birtist bókin í appinu.
      </div>
    </div>
    <div class="comp_assets">
      <div class="asset link" v-for="asset in assets" v-on:click="on_click_play(asset.asset_id, asset.image)">
        <img  class="asset_cover" v-bind:src="'https://hlusta.forlagid.is/i/' + asset.image + '/cover-70@1x.png'">
        <span class="asset_title">{{ asset.title }}</span><br>
        <span class="asset_author">{{ asset.author }}</span><br>
        <div class="asset_bar">
          <div class="progress_bar">
            <div class="progress_done" v-bind:style="'width: ' + parseInt(100 * asset.sec_book_pos / asset.sec_book_total) + '%;'"></div>
          </div> <span class="asset_time_ramaining">{{ render_time_remaining(asset.sec_book_total - asset.sec_book_pos) }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import * as srv from '../srv'
import * as storage from '../storage'
export default {
  data () {
    return {
      assets: storage.assets,
      test: '',
      asset_id: 'not set',
      show_no_asset_msg: false
    }
  },
  methods: {
    on_click_play (asset_id, image) {
      this.$emit('set-asset-info', asset_id, image)
      this.$emit('show-player')
    },
    get_assets () {
      this.show_no_asset_msg = false
      srv.get_assets()
        .then(data => {
          if (data.length === 0) {
            this.show_no_asset_msg = true
          } else {
            this.show_no_asset_msg = false
          }
          this.assets = data
        })
        .catch(srv_err => {
          this.$emit('dialog-message', srv_err.error_text, () => {})
        })
    },
    render_time_remaining (secs_float) {
      let all_secs = parseInt(secs_float)
      let secs = all_secs % 60
      let all_mins = (all_secs - secs) / 60
      let mins = all_mins % 60
      let hours = (all_mins - mins) / 60
      let str = ''
      if (hours > 0) {
        str = `${hours} klst. eftir`
      } else if (mins > 0) {
        str = `${mins} mín. eftir`
      } else if (secs > 5) {
        str = `${secs} sek. eftir`
      } else {
        str = 'lokið'
      }
      return str
    }
  },
  mounted () {
    this.get_assets()
  }
}
</script>

<style>
</style>





// WEBPACK FOOTER //
// src/components/Assets.vue